var map = {
	"./tech-gray-chatgpt.svg": 1192,
	"./tech-gray-excel.svg": 1193,
	"./tech-gray-git.svg": 1194,
	"./tech-gray-google-sheets.svg": 1195,
	"./tech-gray-jupyter.svg": 1196,
	"./tech-gray-multiple.svg": 1197,
	"./tech-gray-other.svg": 1198,
	"./tech-gray-powerbi.svg": 1199,
	"./tech-gray-python.svg": 1200,
	"./tech-gray-r.svg": 1201,
	"./tech-gray-sql.svg": 1202,
	"./tech-gray-tableau.svg": 1203,
	"./tech-gray-theory.svg": 1204
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2179;